<template>
  <component :is="currentTermsComponent" />
</template>

<script>
import TermsGold from './terms/termsGold.vue'
import TermsBlue from './terms/termsBlue.vue'
import TermsPurple from './terms/termsPurple.vue'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    TermsGold,
    TermsBlue,
    TermsPurple
  },
  mixins: [themeMixin],
  computed: {
    currentTermsComponent() {
      switch (this.currentTheme) {
        case 'theme_blue':
          return 'TermsBlue'
        case 'theme_purple':
          return 'TermsPurple'
        case 'theme_gold':
        default:
          return 'TermsGold'
      }
    }
  }
}
</script>
